import Icon from "./IconBase.js";

const BellIcon = (props) => {
  return (
    <Icon width="16" height="20" viewBox="0 0 16 20" {...props}>
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8589 11.0822L13.8577 9.18753C13.8576 7.90695 13.3885 6.66389 12.5263 5.65934C11.6642 4.6548 10.4593 3.94751 9.10653 3.65184C9.11681 3.61509 9.1248 3.57783 9.13046 3.54025L9.12879 1.05186C9.1286 0.772689 9.00802 0.505033 8.79356 0.307773C8.5791 0.110513 8.28833 -0.000193179 7.98523 9.94466e-06C7.68212 0.000213068 7.39151 0.111308 7.17731 0.308856C6.96312 0.506403 6.84289 0.774221 6.84308 1.05339L6.84474 3.54178C6.85045 3.57936 6.85849 3.61661 6.86882 3.65334C5.51646 3.95082 4.31253 4.65973 3.4517 5.66542C2.59087 6.67112 2.12348 7.91481 2.1251 9.19539L2.12637 11.0901C2.12806 13.6016 -0.00523767 14.2304 -0.00439613 15.4862C-0.00397782 16.1104 -0.00355444 16.742 0.611303 16.7416L15.3816 16.7317C15.9964 16.7312 15.996 16.0997 15.9956 15.4755C15.9948 14.2197 13.8606 13.5938 13.8589 11.0822Z"
          fill="white"
        />
        <path
          d="M4.36629 17.7917C4.66991 18.4473 5.17612 19.0062 5.82196 19.3988C6.46779 19.7915 7.22474 20.0005 7.99863 20C8.77252 19.9995 9.52919 19.7894 10.1745 19.3959C10.8198 19.0024 11.3253 18.4428 11.628 17.7868L4.36629 17.7917Z"
          fill="white"
        />
      </svg>
    </Icon>
  );
};

export default BellIcon;
